import { service } from '../axios';
export function addAssessmentLearning(data) {
    return service({
        url: '/assessment/learning/add',
        method: 'post',
        data
    });
}
export function getQuestionsByIdsRiskCheck(questionIds) {
    return service({
        url: '/exam/getQuestionsByIds',
        method: 'get',
        params: { questionIds: questionIds.join(',') } // 逗号分隔传参
    });
}
export function saveExamFixedQuestionsRiskCheck(data) {
    return service({
        url: '/exam/saveExamFixedQuestions',
        method: 'post',
        data
    });
}
//统计试卷分数
export function reAssessmentTotalRiskCheck(assessmentId) {
    return service({
        url: '/exam/reAssessmentTotal',
        method: 'post',
        params: { assessmentId }
    });
}
//检查配置是否ok
export function checkAssessmentRuleRiskCheck(assessmentId) {
    return service({
        url: '/exam/checkAssessmentRule',
        method: 'post',
        params: { assessmentId }
    });
}
// 生成试卷
export function generatePaperRiskCheck(data) {
    return service({
        url: '/exam/generatePaper',
        method: 'post',
        data
    });
}
// 提交答案
export function submitAnswersRiskCheck(data) {
    return service({
        url: '/exam/submitAnswers',
        method: 'post',
        data
    });
}
// 加载答题记录接口
export function loadExamAnswersRiskCheck(data) {
    return service({
        url: '/exam/loadExamAnswers',
        method: 'post',
        data
    });
}
export function generateCertificateRiskCheck(data) {
    return service({
        url: '/certificate/generate',
        method: 'post',
        data: {
            examRecordId: data.examRecordId
        }
    });
}
export function getExamUsers(data) {
    return service({
        url: '/exam/getExamUsers',
        method: 'post',
        data
    });
}
export function getExamStatusStat(data) {
    return service({
        url: '/exam/getExamStatusStat',
        method: 'post',
        data
    });
}
export function viewCertificateQRCodeRiskCheck(certificateId) {
    return service({
        url: '/certificate/viewQRCode',
        method: 'get',
        params: { certificateId }
    });
}
export function getStudyHome() {
    return service({
        url: '/studyHome/getStudyHome',
        method: 'get'
    });
}
export function getRiskOrgStat(params) {
    return service({
        url: '/studyHome/getRiskOrgStat',
        method: 'get',
        params
    });
}
export function getMajorExamStats(params) {
    return service({
        url: '/studyHome/getMajorExamStats',
        method: 'get',
        params
    });
}
export function getStudyExamStatus(data) {
    return service({
        url: '/studyHome/getExamStatus',
        method: 'post',
        data
    });
}
